// Activity-ring style progress indicator with initials in the centre.
import React from 'react';

export function Ring({ pct, initials, size = 56, stroke = 5, testId }) {
  const r = (size - stroke) / 2; const c = 2 * Math.PI * r; const done = pct >= 100;
  return (
    <span className="relative grid shrink-0 place-items-center" style={{ width: size, height: size }} data-testid={testId}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(0,0,0,0.06)" strokeWidth={stroke} />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={done ? '#34C759' : '#15133A'} strokeWidth={stroke} strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c - (c * Math.min(100, Math.max(0, pct))) / 100} className="transition-[stroke-dashoffset,stroke] duration-700 ease-out" />
      </svg>
      <span className={`absolute text-[12px] font-semibold tracking-tight ${done ? 'text-[#1E7F3B]' : 'text-[#1d1d1f]'}`}>{initials}</span>
    </span>
  );
}
